import { useQuery } from '@tanstack/react-query';
import { startOfWeek, endOfWeek } from 'date-fns';
import { scheduleKeys } from './queryKeys';
import { fetchMyShifts } from '@/services/schedule/shiftService';
import { Shift } from '@/services/schedule/types';

export const useMyShifts = (
  profileId: string | undefined, 
  currentWeek: Date, 
  profile: any
) => {
  const weekStartISO = startOfWeek(currentWeek).toISOString();
  const weekEndISO = endOfWeek(currentWeek).toISOString();
  
  return useQuery({
    queryKey: scheduleKeys.myShifts(profileId || '', weekStartISO, weekEndISO),
    queryFn: async () => {
      if (!profileId) throw new Error('Profile ID required');
      const data = await fetchMyShifts(profileId, weekStartISO, weekEndISO);
      
      // Enrich shifts with employee name - preserve database values including swap_status
      const enrichedShifts: Shift[] = data.map(shift => ({
        ...shift,
        employee_name: `${profile?.first_name || ''} ${profile?.last_name || ''}`.trim() || 'You',
      }));
      
      return enrichedShifts;
    },
    enabled: !!profileId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
};
